import { useTypedSelector } from "@hooks/useTypedSelector";
import { useActions } from "@hooks/useActions";
import React, { useEffect } from "react";
import { Button2, DateTimePicker, Type as T } from "@infobis/ui-styles-utils";
import colors from "@infobis/ui-styles-utils/colors";
import { formatDateWithTemplate } from "@utils/format/date";
import { addHours, addMinutes, isToday, startOfDay } from "date-fns";

const DateSelector = () => {
	const { selectedDate } = useTypedSelector(state => state.selectedDate)
	const { selectDate } = useActions()
	const { fetchCrops } = useActions()

	const processDateSelect = (pickedDate: Date) => {
		selectDate(pickedDate)
		fetchCrops({ date: pickedDate.getTime() })
	}

	const handleDatePick = (date: Date) => {
		const pickedDate = isToday(date) ? new Date() : addMinutes(addHours(startOfDay(date), 23), 59)
		processDateSelect(pickedDate)
	}

	useEffect(() => {
		// Если дата не выбрана (например, при первом запуске приложения), то устанавливаем текущую дату и выполняем запрос культур
		if (!selectedDate) processDateSelect(new Date())
	}, [selectedDate]);

	return (
		<DateTimePicker withInput={true}
						isRangePicker={false}
						useTime={false}
						withToday
						inputProps={{ label: 'Выберите дату', required: true }}
						value={selectedDate ? [selectedDate] : [new Date()]}
						onChange={([date]) => handleDatePick(date)}>
			{(props) =>
				<div ref={props.ref}>
					<Button2.Contrast.IconL size={T.Sizes.S}
											icon={T.IconName.Calendar}
											style={{ color: colors.TYPO_PRIMARY }}
											iconColor={colors.CONTROL_DEFAULT_ICON_ICON}
											onClick={props.togglePicker}>
						{selectedDate ? formatDateWithTemplate(selectedDate.valueOf(), 'D MMMM YYYY') : 'Выберите дату'}
					</Button2.Contrast.IconL>
				</div>
			}
		</DateTimePicker>
	)
}

export default DateSelector;